var React = require('react');

function N3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"N3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"0 0 0 84.23 33.64 84.23 68.68 84.23 0 0","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"72.7 6.88 49.34 4.92 45.04 56.23 45.04 56.23 44.45 63.29 58.49 84.26 58.49 84.26 65.35 94.51 72.7 6.88","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

N3.defaultProps = {"viewBox":"0 0 72.7 94.51"};

module.exports = N3;

N3.default = N3;
